import { render, staticRenderFns } from "./H5Layout.vue?vue&type=template&id=4f58817d&scoped=true&"
import script from "./H5Layout.vue?vue&type=script&lang=js&"
export * from "./H5Layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f58817d",
  null
  
)

export default component.exports